import React, {useState, useEffect, useRef} from 'react'
import styled from '@emotion/styled';
import client from '../../src/graphql/client';
import {gql} from "@apollo/client";
import {get, uniq, findIndex, groupBy} from 'lodash';
import {Grid, Box, ButtonBase} from '@mui/material';
import qs from 'qs';
import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';
import withWidth from '../../src/components/hoc/withWidth';
import Disclaimer from '../../src/components/ui/Disclaimer';

import {theme} from '../../src/themes/default-theme';
import seoQuery from '../../src/graphql/queries/seo';
import contentBuilderQuery from '../../src/graphql/queries/content-builder';
import respImgQuery from '../../src/graphql/queries/resp-img';
import {sellsMotorhomes, sellsCampervans} from '../../src/util/filterDealerMotorHomes';

import refactorSurveyPage from '../../src/data-restructure/pages/find-my-perfect-jayco/survey';

// components
import Text from '../../src/components/typography';
import CheckThumbnail from '../../src/components/ui/CheckThumbnail';
import Cta from '../../src/components/ui/Cta';
import BannerPopup from '../../src/components/ui/BannerPopup';
import topo from '../../src/assets/topo.png';
import ProgressBar from '../../src/components/ui/ProgressBar'
import OptionSelect from '../../src/components/ui/OptionSelect';
import SleepSelect from '../../src/components/ui/SleepSelect';
import SeriesCard from '../../src/components/navigation/NewMainNav/SeriesCard';
import NextLink from '../../src/components/navigation/NextLink';
import equalizer from 'react-equalizer';

const Container = styled.div`
  padding: 65px 0;
  position: relative;
  background-color: ${theme.palette.lightGrey};

  &:before {
    height: 60px;
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    background-position: center top;
    background-image: url(${topo});
    background-size: 400px auto;
    background-repeat: repeat-x;

    ${theme.breakpoints.down('sm')} {
      height: 25px;
    }
  }

  h1 {
    margin-top: 70px;

    ${theme.breakpoints.down('sm')} {
      margin-top: 15px;
    }
  }

`

const IconContainer = styled.div`
  margin: 10px auto 50px;
  ${theme.breakpoints.up('md')} {
    margin: 30px auto 40px;
  }
`

const Step = styled.div`
  margin: 30px auto;

  ${theme.breakpoints.up('md')} {
    margin: 45px auto;
  }
`

const Thumbnails = styled.div`
  display: flex;
  justify-content: center;
  max-width: 1430px;
  margin: 0 auto;
  padding: 0 5px;
  flex-wrap: wrap;

  ${theme.breakpoints.down('md')} {
    justify-content: center;
    flex-wrap: nowrap;
  }
`

const Thumbnail = styled.div`
  padding: 10px;

  ${theme.breakpoints.up('md')} {
    width: 25%
  }
`

const ThumbnailDropdown = styled.div`
  margin-top: 30px;
`

const HowMany = styled.div`
  margin: 0 auto;
  font-size: 0;
  text-align: center;
  padding: 0 ${theme.containers.main.gutter};
  max-width: 580px;

  ${theme.breakpoints.up('md')} {
    max-width: 100%;
  }
`

const HowManyContainer = styled.div`
  text-align: center;
  background-color: ${theme.palette.lightBlue};
  margin-bottom: 10px;
  width: 100%;
  border-radius: 35px;
  display: flex;
  justify-content: space-evenly;

  ${theme.breakpoints.up('md')} {
    display: inline-block;
    width: auto;
    border-radius: 0;
    
    &:first-child {
      border-top-left-radius: 35px;
      border-bottom-left-radius: 35px;
      padding-left: 69px;
    }
    &:last-child {
      border-top-right-radius: 35px;
      border-bottom-right-radius: 35px;
      padding-right: 69px;
    }
  }

  ${theme.breakpoints.up('lg')} {
    
    &:first-child {
      padding-left: 79px;
    }
    &:last-child {
      padding-right: 79px;
    }
  }
`

const HowManyItem = styled(ButtonBase)`
  display: inline-block;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  color: ${theme.palette.gunmetalGrey};
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  border-radius: 50px;

  &:hover {
    ${props => props.active === 0 && `background-color: ${theme.palette.middleGrey};`}
  }

  ${props => props.active === 1 && `
    background-color: ${theme.palette.vividBlue};
    color: ${theme.palette.white};
  `}

  ${theme.breakpoints.up('md')} {
    width: 69px;
    height: 69px;
    line-height: 69px;
    font-size: 34px;
    border-radius: 69px;
  }

  ${theme.breakpoints.up('lg')} {
    width: 70px;
    height: 70px;
    margin: 0 5px;
    line-height: 70px;
    font-size: 34px;
    border-radius: 70px;
  }
`

const CaravanCardContainer = styled.div`
  max-width: 335px;
  margin: 0 auto;
  text-align: center;
  margin-bottom: 20px;

  * {
    text-align: center;
    justify-content: center;
  }

  > div {
    max-width: 100%;
    > div {
      max-width: 100%;
    }
  }

  a {
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .explore {
    margin-top: 15px;
  }
`


const Footer = styled.div `
  margin: 0 0 60px;

  ${theme.breakpoints.up('md')} {
    margin: 60px 0;
  }
`

const Ctas = styled.div `
  text-align: center;
  padding: 0 ${theme.containers.main.gutter};

  ${theme.breakpoints.up('md')} {
    padding: 0;
  }

`

const CtasContainer = styled.div `
  padding: 10px 0;

  ${theme.breakpoints.up('md')} {
    padding: 30px;
    border-top: 1px solid ${theme.palette.middleGrey};
  }
`

const CtaItem = styled.div`
  margin: 20px 0;

  button {
    width: 210px;
  }

  h5 {
    margin-bottom: 10px;
  }

  p {
    margin-top: 0;
  }

  ${theme.breakpoints.up('md')} {

    button {
      width: auto;
    }
  }
`

const NoResults = styled.div`
  text-align: center;
`

const DisclaimerWrapper = styled.div`
  padding: 30px 0;
  background-color: ${theme.palette.lightGrey};
  text-align: center;
  p {
    font-size: 12px;
  }
  ${theme.breakpoints.up('lg')} {
    padding: 55px 0;
  }
`

const NextBtn = styled.div`
  text-align: center;
`

const ModelContainer = styled.div`
  margin-top: 20px;
`
const Model = styled.div`
  text-align: center;
  margin-bottom: 5px;

  > span,
  > a {
    display: inline-block;
    border: 1px solid ${theme.palette.middleGrey};
    color: ${theme.palette.gunmentalGrey};
    padding: 2px 14px;
    border-radius: 25px;
    text-decoration: none;
    background-color: white;

    a {
      text-decoration: none;
      color: ${theme.palette.gunmentalGrey};
    }
  }
`

const ThumbnailsContainer = styled.div`
  max-width: 1000px;
  margin: 0 auto;
`

const AnimateGrid = styled(Grid)`
  @keyframes FadeIn { 
    0% {
      opacity: 0;
      transform: translateY(20px);
    }

    100% {
      transform: scale(1);
      transform: translateY(0);
    }
  }

  > div {
    opacity: 1;
    animation: FadeIn 0.5s backwards;
  }
`

const usePrevious = (value) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

const FindMyPerfectJaycoSurvey = (props) => {
  const initialVisibleModels = 6;
  const initialSleepState = {
    adults: 1,
    children: 0
  }
  const [step, setStep] = useState(1);
  const [stepsValid, setStepsValid] = useState({});
  const [adventureSpecs, setAdventureSpecs] = useState([]);
  const [show, setShowMore] = useState(initialVisibleModels);
  const [savedItems, setSavedItems] = useState([]);
  const [modelThumbnails, setModelThumbnails] = useState(props.models)
  const [adventureThumbnails, setAdventureThumbnails] = useState([]);
  const [compareItems, setCompareItems] = useState([]);
  const [curWidth, updateCurWidth] = useState(props.width);
  const maxToCompare = typeof window !== 'undefined' ? (theme.isWidthUp('md', props.width) ? 3 : 2) : 2;
  const minToCompare = 2;
  const [compareUrl, updateCompareUrl] = useState('');
  const defaultSleeps = {
    maxAdults: 1,
    maxChildren: 0
  }
  const [maxSleeps, setMaxSleeps] = useState(defaultSleeps);


  const driveIt = !process.env.DEALER_SITE ? true : (sellsMotorhomes() !== false || sellsCampervans() !== false);
  const campervansOnly = process.env.DEALER_SITE && sellsMotorhomes() === false && sellsCampervans() !== false;


  const initialState = {
    exp: null,
    expTow: null,
    howMany: initialSleepState,
    adventure: null,
    adventureSpecs: [],
  }

  const [state, setState] = useState(initialState);

  const reset = () => {

    setStep(1);
    setAdventureSpecs([]);
    setShowMore(initialVisibleModels);
    setModelThumbnails(props.models);
    setCompareItems([])
    setState(initialState)
  }

  useEffect(() => {
    const compareData = compareItems.map(item => { return {
      range: item.rangeId,
      series: item.seriesId,
      model: item.layoutId,
    }})
    const param = qs.stringify({items: compareData});
    updateCompareUrl(param)
  }, [compareItems])

  useEffect(() => {
    // If width changes from md to sm/xs & compare items length is at max then clear items (2 items for sm, 3 for md up)
    if (
      ((compareItems.length === 3) && curWidth !== 'sm' && curWidth !== 'xs') && (props.width === 'sm' || props.width === 'xs')
    ) {
      setCompareItems([])
    }
    updateCurWidth(props.width);
  }, [props.width])

  useEffect(() => {
    const qsData = qs.parse(window.location.search.replace('?',''));
    const {
      step
    } = qsData
    qsData.state && setState({...state, ...qsData.state})
    step && setStep(parseInt(step))

    if (driveIt === false) {
      setState({
        ...state,
        exp: 'tow'
      })
    }
  }, [])

  const prevStateState = usePrevious(state);
  const prevStepState = usePrevious(step);

  useEffect(() => {
    const params = {
      state,
      step
    }

    const param = qs.stringify(params);

    if (prevStateState || prevStepState) {
      // To prevent any slow routing on development
      window.history.pushState('', '', `?${param}`)
    }
    
    // validate
    const valid = {
      ...stepsValid
    }

    valid['2'] = state.howMany && state.howMany !== '' ? true : false
    
    if (state.exp && state.exp.length > 0) {
      if (state.exp === 'tow' && state.expTow && state.expTow.length > 0) {
        valid['1'] = true
      } else if (state.exp === 'tow' && (!state.expTow || state.expTow.length === 0)) {
        valid['1'] = false
      } else {
        valid['1'] = true
      }
    } else {
      valid['1'] = false
    }
    valid['3'] = state.adventure && state.adventure.length > 0 ? true : false

    setStepsValid(valid);
    setCompareItems([]);

    if (step === 3) {
      setMaxSleeps(getMaxSleeps(true));
    }

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });

  }, [step]);

  useEffect(() => {

    const filteredModels = props.models
    .filter(item => {
      // drive or tow
      return state.exp === item.type
    })
    .filter(item => {
      // how many

      const itemSleepsAdults = item.seriesDetails.sleepsAdult
      const itemSleepsChild = item.seriesDetails.sleepsOptional

      if (parseInt(state.howMany.adults) <= parseInt(itemSleepsAdults) && parseInt(state.howMany.children) <= parseInt(itemSleepsChild)) {
        return true;
      }

    })
    .filter(item => {
      // weight
      const itemWeight = item.weight ? parseInt(item.weight) : null;
      const stateWeight = get(state, 'expTow.value', null) ? parseInt(state.expTow.value) : null;
      if (state.exp === 'tow' && itemWeight && stateWeight) {
        return itemWeight < stateWeight
      } else {
        return true
      }
    });

    setAdventureThumbnails(filteredModels);

    setModelThumbnails(filteredModels.filter(item => {
      // spec
      const spec = item.seriesType.toLowerCase().trim(); // Note: seriesType actually spec in this instance.
      const range = item.range.toLowerCase().trim(); // Note: seriesType actually spec in this instance.
      return (get(adventureSpecs, '[0]', []).indexOf(spec) !== -1 || get(adventureSpecs, '[0]', []).indexOf(range) !== -1)
    }));

  }, [state, adventureSpecs]);


  const handleTabChange = (step) => {

    if(step === 2 && state.exp === 'drive') {
      setStep(1);
    } else {
      setStep(step);
    }

  }

  const handleNext = (e) => {
    e.preventDefault();
    setStep(step + 1);
    if (step + 1 === 3) {
      // (true);
    }
  }

  useEffect(() => {
    setSaved()
    document.addEventListener("ls:change", setSaved);
    return () => window.removeEventListener("ls:change", setSaved);
  },[])

  useEffect(() => {
    let specs = [];
    const adventureThumbs = get(props, 'adventureStep.items', null);

    if (!adventureThumbs) {
      return;
    }

    adventureThumbs.forEach(thumb => {
      const advSpecs = thumb.spec.toLowerCase().split(',')
      if(state.adventure === thumb.title) {
        specs.push([...advSpecs.map(item => item.trim())])
      }
    })

    setAdventureSpecs(uniq(specs));

  }, [state.adventure])

  const handleAdventureChange = (item) => {
    // Single value only in 2023 refresh 
    setState({
      ...state,
      adventure: item
    });

    setStep(5)
  }

  const setSaved = () => {
    const savedCaravans = get(window, 'localStorage.savedCaravans', null);
    if (savedCaravans && savedCaravans.length > 0) {
      const parsedSavedCaravans = JSON.parse(savedCaravans);
      setSavedItems(parsedSavedCaravans.map(item => item.id));
    }
  }

  const handleShowMore = () => {
    const inc = 6;
    setShowMore(show + inc)
  }

  const handleExpTowChange = (e) => {
    const item = get(props, 'expStep.towItems', []).find(item => item.text === e.text)
    setState({
      ...state,
      expTow: item
    })
  }

  const activeItem = findIndex(get(props, 'expStep.towItems', []), state.expTow)

  const handleSleepChange = (type, value) => {
    const sleepsType = type === 'adults' ? 'maxAdults' : 'maxChildren'

    const val = type === 'adults' && parseInt(value) === 0 ? 1 : (parseInt(value) === -1 ? 0 : parseInt(value))
    
    // check if type == adult then filter though values < adults and then return 'children' : value in state.howMany below
    // maybe for loop after to get the max children from the adults selected?

    let changeChild = {}
    let maxChildren = 0

    if (type === 'adults') {

      const filteredModels = props.models
      .filter(item => {
        // drive or tow
        return state.exp === item.type
      })
      .filter(item => {
        // how many
  
        if (val > get(item, 'seriesDetails.sleepsAdult', 0)) {
          return false;
        } else {
          return true
        }
  
      })
      .filter(item => {
        // weight
        const itemWeight = item.weight ? parseInt(item.weight) : null;
        const stateWeight = get(state, 'expTow.value', null) ? parseInt(state.expTow.value) : null;
        if (state.exp === 'tow' && itemWeight && stateWeight) {
          return itemWeight < stateWeight
        } else {
          return true
        }
      });

      // const filteredModels = props.models.filter(item => {
      //   if (val > get(item, 'seriesDetails.sleepsAdult', 0)) {
      //     return false
      //   } else {
      //     return true
      //   }
      // });

      for (var i = 0; i < filteredModels.length; i++) {
        const model = filteredModels[i];
        const sleepsOptional = get(model, 'seriesDetails.sleepsOptional', 0)//  + get(model, 'seriesDetails.sleepsChildren', 0)
        if ( sleepsOptional > maxChildren) {
          maxChildren = sleepsOptional
        }
      }

      changeChild = maxChildren < state.howMany.children ? {
        children: maxChildren
      } : {}

      setMaxSleeps({
        ...maxSleeps,
        maxChildren: maxChildren
      })

    }
    
    if (value <= maxSleeps[sleepsType]) {
      setState({
        ...state,
        howMany: {
          ...state.howMany,
          ...changeChild,
          [type]: val
        }
      })
    } else {
      setState({
        ...state,
        howMany: {
          ...state.howMany,
          ...changeChild,
          [type]: parseInt(maxSleeps[sleepsType])
        }
      })
    }

  }

  const getMaxSleeps = (reset, checkChildren) => {

    const _filteredModels = props.models
    .filter(item => {
      // drive or tow
      return state.exp === item.type
    })
    .filter(item => {
      // weight
      const itemWeight = item.weight ? parseInt(item.weight) : null;
      const stateWeight = get(state, 'expTow.value', null) ? parseInt(state.expTow.value) : null;
      if (state.exp === 'tow' && itemWeight && stateWeight) {
        return itemWeight < stateWeight
      } else {
        return true
      }
    });

    var filteredModels;

    // if (checkChildren) {
    //   filteredModels = _filteredModels.filter(item => {
    //     if (state.howMany.adults >= get(item, 'seriesDetails.sleepsAdult', 0)) {
    //       return false
    //     } else {
    //       return true
    //     }
    //   })
    // } else {
    //   filteredModels = _filteredModels
    // }

    filteredModels = _filteredModels

    let maxAdults = 0;
    let maxChildren = 0;

    for (var i = 0; i < filteredModels.length; i++) {
      const model = filteredModels[i];
      const sleepsAdult = get(model, 'seriesDetails.sleepsAdult', 0)
      const sleepsOptional = get(model, 'seriesDetails.sleepsOptional', 0)//  + get(model, 'seriesDetails.sleepsChildren', 0)
      if ( sleepsAdult > maxAdults) {
        maxAdults = sleepsAdult
      }
      if ( sleepsOptional > maxChildren) {
        maxChildren = sleepsOptional
      }
    }

    if (reset) {
      setState({
        ...state,
        howMany: {
          ...state.howMany,
          adults: parseInt(state.howMany.adults) < maxAdults ? parseInt(state.howMany.adults) : maxAdults,
          children: parseInt(state.howMany.children) < maxChildren ? parseInt(state.howMany.children) : maxChildren,
        }
      })
    }

    return {
      maxAdults,
      maxChildren
    }

  }

  const adventureItems = props.adventureStep.items.filter(adventureSpec => {

    const itemWithSpec = adventureThumbnails.find(item => {
      const spec = item.seriesType.toLowerCase().trim(); // Note: seriesType actually spec in this instance.
      return get(adventureSpec, 'spec', '').toLowerCase().indexOf(spec) !== -1;
    })

    return itemWithSpec ? true : false
  });

  const seriesThumbnailsGroup = groupBy(modelThumbnails, (item) => item.title);
  const seriesThumbnails = Object.entries(seriesThumbnailsGroup).map(item => {
    let maxSleeps = 0;
    item[1].forEach(item => {
      const totalSleep = parseInt(get(item, 'seriesDetails.sleepsAdult', 0) + get(item, 'seriesDetails.sleepsOptional', 0))
      if (totalSleep > maxSleeps) {
        maxSleeps = totalSleep
      }
    })
    return {
      ...item[1][0],
      models: item[1],
      href: item[1][0].href.split('?floorplan')[0],
      sleepsText: `up to ${maxSleeps}`
    }
  }).filter(item => {
    if (campervansOnly && item.range && (item.range.toLowerCase() === 'motorised' || item.range.toLowerCase() === 'motorhomes')) {
      return false;
    } else {
      return true
    }
  });

  console.log('campervansOnly', campervansOnly, seriesThumbnails)

  const equalizeTitle = () => {
    const items = document.querySelectorAll('[data-survey-equalize]');
    
    if (items.length > 0) {
      let heights = [];
      for (let i = 0; i < items.length; i++) {
        items[i].style.height = 'auto';
        heights.push(items[i].offsetHeight);
      }
      const tallest = Math.max(...heights);

      for (var i = 0; i < items.length; i++) {
        items[i].style.height = tallest + 'px';
      }
    }
  }

  useEffect(() => {
    setTimeout(() => {
      equalizeTitle();
    }, 350)
    
  }, [modelThumbnails])
 
  useEffect(() => {
    window.addEventListener("resize", equalizeTitle);
    return () => window.removeEventListener("resize", equalizeTitle);
  },[])
  
  // getNodes(equalizerComponent, equalizerElement) {
  //   return = [
  //     this.refs.node1,
  //     this.refs.node2,
  //     this.refs.node3
  //   ]
  // }

  console.log('stateeee', state);

  return (
    <Container>
      <Grid container direction={'row'} alignItems={'flex-start'}>
        <Grid size={12}>
          <Box px={2}>
              <Text variant="h1" colour="charcoal" align="center" uppercase>{step === 5 ? "Here's your perfect Jayco" : 'Find my perfect Jayco'}</Text>
              {step !== 5 && <Text variant="body1" align="center"><p>Take our simple survey to learn which of our models is right for you</p></Text>}
          </Box>
        </Grid>
      </Grid>
      <IconContainer>
        <ProgressBar
          steps={4}
          active={step}
          onChange={handleTabChange}
          state={state}
        />

      </IconContainer>
      {step === 1 &&
        <>
          <Text variant="h4" colour="charcoal" align="center">{props.expStep.heading}</Text>
          <Step>
            <Thumbnails>
              
              {driveIt ? (
                <Thumbnail onClick={() => {
                  setState({
                    ...state,
                    exp: 'drive',
                    howMany: initialSleepState // reset
                  });
                  // setMaxSleeps(defaultSleeps);
                  setStep(3);
                }}>
                  <div>
                    <CheckThumbnail
                      title={get(props, 'expStep.drive.title',  null)}
                      image={get(props, 'expStep.drive.image',  null)}
                      // active={state.exp === 'drive'}
                    />
                  </div>
                </Thumbnail>
              ) : null}
                <Thumbnail>
                  <div onClick={() => {
                    setState({
                      ...state,
                      exp: 'tow'
                    });
                    setStep(2);
                  }}>
                    <CheckThumbnail
                      title={get(props, 'expStep.tow.title',  null)}
                      image={get(props, 'expStep.tow.image',  null)}
                      // active={state.exp === 'tow'}
                    />
                  </div>
                
                </Thumbnail>
             
            </Thumbnails>

          </Step>
        </>
      }
      {step === 2 &&
        <>
          <Text variant="h4" colour="charcoal" align="center">How much weight can your vehicle tow?</Text>
          <Step>
            <OptionSelect
              items={get(props, 'expStep.towItems', [])}//.map(item => item.value)}
              activeIndex={activeItem || 0}
              onChange={handleExpTowChange}
            />
          </Step>
        </>
      }
      {step === 3 &&
        <>
          <Text variant="h4" colour="charcoal" align="center">{props.howManyStep.heading}</Text>
          <Step>
            <HowMany>

              <SleepSelect
                  adults={state.howMany.adults}
                  children={state.howMany.children}
                  max={maxSleeps}
                  onChange={handleSleepChange}
              />

            </HowMany>
          </Step>
        </>
      }
      {step === 4 &&
        <>
          <Text variant="h4" colour="charcoal" align="center">{props.adventureStep.heading}</Text>
          <Step>
            
            <Thumbnails>
              {adventureItems.map(item => (
                <Thumbnail onClick={() => handleAdventureChange(item.title)} key={item.title}>
                  <CheckThumbnail
                    title={get(item, 'title',  null)}
                    image={get(item, 'image',  null)}
                    // active={state.adventure === item.title}
                  />
                </Thumbnail>
              ))}
            </Thumbnails>
          </Step>
        </>
      }
      {step === 5 &&
        <>
          <Step>
            
            {seriesThumbnails.length === 0 &&
              <Grid container direction={'row'} alignItems={'flex-start'}>
                <Grid size={12}>
                  <Box px={2}>
                    <NoResults>
                      <Text variant="body1" colour="charcoal" align="center">Sorry there are no results that match your criteria. Try adjusting your criteria to find a match.</Text>
                    </NoResults>
                  </Box>
                </Grid>
              </Grid>
            }
            <ThumbnailsContainer>
              {/* <Equalizer nodes={getNodes()}> */}
                <AnimateGrid container direction={'row'} alignItems={'flex-start'} justifyContent="center">
                  {seriesThumbnails.map((item, index) => {
                    return (index) < show ? (
                      <Grid
                        key={item.id}
                        style={{animationDelay: `${(index+1) * 0.3}s`}}
                        size={{
                          xs: 6,
                          md: 6,
                          lg: 4
                        }}>
                        <Box px={2}>
                          <CaravanCardContainer>
                            <div data-survey-equalize>
                              <SeriesCard
                                // ref={`node${index}`} 
                                href={item.href}
                                title={item.title}
                                subTitle={item.seriesType}
                                sleeps={item.sleepsText.replace('up to', '') || parseInt(get(item, 'seriesDetails.sleepsAdult', 0) + get(item, 'seriesDetails.sleepsOptional', 0))}
                                image={item.image}
                                hasborder='false'
                                mobileStyles={false}
                              />
                            </div>
                            <Cta href={item.href} inline className="explore">EXPLORE</Cta>
                            <ModelContainer>
                              {item.models.map(item => {
                                return <Model key={item.id}>
                                    <NextLink href={item.href}>
                                      {item.layoutName}
                                    </NextLink>
                                  </Model>
                              })}
                            </ModelContainer>
                          </CaravanCardContainer>
                        </Box>
                      </Grid>
                    ) : null;
                  })}
                </AnimateGrid>
              {/* </Equalizer> */}
            </ThumbnailsContainer>
            <Footer>
              <Grid container direction={'row'} align={'left'}>
                <Grid size={12}>
                  <Box px={2}>
                    <Ctas>
                      <CtasContainer>
                        <CtaItem>
                          <Text variant="h5" colour="black" align="center">Didn't find what you're looking for?</Text>
                          <Text variant="body1" align="center"><p>Try adjusting your criteria to find a match.</p></Text>
                          <Cta outline onClick={reset}>Start over</Cta>
                          <br />
                        </CtaItem>
                        {show < seriesThumbnails.length &&
                          <CtaItem>
                            <Cta onClick={handleShowMore}>Show more</Cta>
                          </CtaItem>
                        }
                      </CtasContainer>
                    </Ctas>
                  </Box>
                </Grid>
              </Grid>
            </Footer>
          </Step>
          
          <BannerPopup 
            open={compareItems.length > 0}
            cta={{
              title: 'Next',
              href: `/compare?${compareUrl}`,
              disabled: compareItems.length >= minToCompare ? false : true
            }}
            text={`Select a maximum of ${maxToCompare} to compare`}
          />
        </>
      }
      {(step !== 1 && step !== 4 && step !== 5) &&
        <NextBtn>
          <Cta inline onClick={handleNext}>Next</Cta>
        </NextBtn>
      }
      {step === 2 &&
        <DisclaimerWrapper>
          <Grid container className={'hasPadding'} spacing={0} direction={'row'} wrap="nowrap" justify={'center'}>
            <Grid
              size={{
                xs: 12,
                lg: 9
              }}>
              <Box px={2}>
                <Disclaimer>
                  <p>The weights provided are a guide only and will differ depending on the vehicle manufactures specifications and accessories fitted. Please consult your vehicle handbook for towing weights specific to your vehicle. For RV towing weight verification please consult your local Jayco Dealer.</p>
                </Disclaimer>
              </Box>
            </Grid>
          </Grid>
        </DisclaimerWrapper>
      }
    </Container>
  );
}


export async function getStaticProps() {
  
  const countryCode = process.env.DEV_COUNTRY_CODE ? process.env.DEV_COUNTRY_CODE : process.env.COUNTRY_CODE;
  
  const FIND_MY_PERFECT_JAYCO = gql`
    query FIND_MY_PERFECT_JAYCO {
      pageBy(uri: "find-my-perfect-jayco?${countryCode.toLowerCase()}") {
        title
        seo {
          ${seoQuery}
        }
        acf_domains {
          assignedDomains
        }
        ${contentBuilderQuery()}
      }
      findPerfectJaycoBy(uri: "find-my-perfect-jayco?${countryCode.toLowerCase()}") {
        acf_find_perfect_jayco {
          fpjHowManyPeopleHeading
          fpjHowManyPeopleNumber
          fpjRvExperienceHeading
          fpjWhereYouGoItemsRep {
            fieldGroupName
            wygSpec
            wygTitle
          }
          fpjRvExperienceTowOptionsRep {
            rveoMaxTowingWeight
            rveoName
          }
          fpjRvExperienceDriveTitle
          fpjRvExperienceDriveImage {
            ${respImgQuery}
          }
          fpjRvExperienceTowImage {
            ${respImgQuery}
          }
          fpjRvExperienceIcon {
            ${respImgQuery}
          }
          fpjHowManyPeopleIcon {
            ${respImgQuery}
          }
          fpjRvExperienceTowTitle
          fpjWhereYouGoHeading
          fpjWhereYouGoItemsRep {
            wygSpec
            wygTitle,
            wygImage {
              ${respImgQuery}
            }
          }
          fpjWhereYouGoIcon {
            ${respImgQuery}
          }
        }
      }
      modelsFloorPlans(first: 10000) {
        nodes {
          title
          uri
          id
          acf_floor_plan {
            seriesSpec
            modelLayoutId
            modelLayoutName
            modelSleepsAdult
            modelSleepsChild
            modelSleepsOptional
            modelWeightLoading
            modelWeightTare
            modelWeightTowBall
            modelToilet
            modelShower
            modelExternalImagesRep {
              modelExternalImagesRepImage {
                ${respImgQuery}
              }
            }
            modelFloorPlanImage {
              ${respImgQuery}
            }
            modelSeries {
              ... on Series {
                id
                uri
                title
                acf_series {
                  seriesRange {
                    ... on Range {
                      uri
                      id
                      title
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `
  const result = await client.query({
    query: FIND_MY_PERFECT_JAYCO,
  });

  const props = refactorSurveyPage(result);

  return {
    revalidate: (process.env.NEXT_STATIC_EXPORT && process.env.NEXT_STATIC_EXPORT.toString() === 'true') ? false : 1,
    props: {
      ...props,
    }
  }
}

FindMyPerfectJaycoSurvey.propTypes = {
}

export default withWidth(FindMyPerfectJaycoSurvey)